// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","767":"details"}[chunkId] + "." + {"443":"e35c5ca6","767":"e6d1bfeb"}[chunkId] + ".js";
};